export const staticPermissions = {
  FUNNEL_MANAGE: 'funnels:manage',
  SEGMENT_MANAGE: 'segments:manage',
  METAINF_MANAGE: 'metainf:manage',
  AUTHORIZATION_MANAGE: 'authorization:manage',
  LABELS_MANAGE: 'labels:manage',
  METAINF_READ: 'metainf:read',
  AUTHORIZATION_READ: 'authorization:read',
  LABELS_READ: 'labels:read',
  FUNNEL_READ: 'funnels:read',
  SEGMENT_READ: 'segments:read',
  PAYMENT_EXECUTE: 'events:Payment:EXECUTE',
  DAU_EXECUTE: 'events:DAU:EXECUTE',
  WAU_EXECUTE: 'events:WAU:EXECUTE',
  MAU_EXECUTE: 'events:MAU:EXECUTE',
  REGISTER_FIRST_START_EXECUTE: 'events:REGISTER_FIRST_START:EXECUTE',
  SESSION_CLOSE_EXECUTE: 'events:SESSION_CLOSE:EXECUTE',
  DASHBOARDS_READ: 'dashboards:read',
  DASHBOARDS_MANAGE: 'dashboards:manage',
};

export const staticAsyncActionPermission = {
  fetchSegments: 'segments:read',
  fetchFunnels: 'funnels:read',
  fetchMapping: 'metainf:read',
  fetchMetainf: 'metainf:read',
  fetchLabels: 'labels:read',
  fetchGroups: 'authorization:read',
  fetchDashboards: 'dashboards:read',
};

// для возврата запущенного асинхронного запроса в соответствии с разрешениями
// ПЕРЕДЕЛАТЬ в будущем
export const checkAsyncActionPermissionsWithLaunch = (asyncAction, permission) => {
  if (!staticAsyncActionPermission[asyncAction.name]) {
    return asyncAction();
  }

  if (permission.has(staticAsyncActionPermission[asyncAction.name])) {
    return asyncAction();
  }
  return 1;
};
